"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shimLocals = void 0;
exports.shimLocals = function (lng) {
    return lng.includes('zh') ? 'zh-cn' : lng;
};
